export class ClientConsentRequest {
    clientCode: string;
    oneViewAccountId: string;
}